import { render, staticRenderFns } from "./DashboardSettingsBillingCollectionItem.vue?vue&type=template&id=5a5352f5&"
import script from "./DashboardSettingsBillingCollectionItem.vue?vue&type=script&lang=ts&"
export * from "./DashboardSettingsBillingCollectionItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports